import script from "./RotationChart_setup.vue?vue&type=script&lang=ts&setup=true"
export * from "./RotationChart_setup.vue?vue&type=script&lang=ts&setup=true"

import "./RotationChart_setup.vue?vue&type=style&index=0&id=936f241c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-936f241c"]])

export default __exports__